<template>
    <div class="setting-wrapper">
        <div class="setting">
            <h4 class="lg:w-1/5">
                {{ lang('Nummerhantering','Number settings') }}
            </h4>
            <div v-if="toggled" class="text-sm text-neutral-dark mb-lg md:mb-xl lg:hidden">
                {{ description }}
            </div>
            <div class="w-full flex items-center w-full lg:w-4/5">
                <div class="w-full mr-auto text-sm text-neutral-darker lg:w-5/6">
                    <div class="w-full flex flex-col md:flex-row">
                        <div class="w-full md:w-1/4 md:mr-sm">
                            <select-input
                                v-model="areaCode"
                                :options="areaCodesForSelect"
                                name="area_code"
                                :label="lang('Riktnummer','Area code')"
                                :required="true"
                                :tabindex="1"
                            >
                                {{ lang('Riktnummer','Area code') }}
                            </select-input>
                        </div>
                        <div class="w-full md:w-1/4 md:mr-sm">
                            <select-input
                                v-model="phoneNumber"
                                :options="availablePhoneNumbers"
                                name="phone_number"
                                :placeholder="lang('Välj nummer','Select phone number')"
                                :required="true"
                                :tabindex="1"
                                :disabled="isLoading"
                            >
                                {{ lang('Telefonnummer','Phone number') }}
                            </select-input>
                        </div>
                        <div class="w-full md:w-1/4 md:mr-sm">
                            <order-date-picker
                                v-model="startDate"
                                name="start_date"
                                :min="deliveryMinDate"
                                :max="deliveryMaxDate"
                                :label="lang('Startdatum', 'Start date')"
                                :required="true"
                            />
                        </div>
                    </div>
                </div>
                <a
                    class="absolute pin-t pin-r flex items-center mt-xl lg:relative lg:mt-0 text-neutral-darker read-more"
                    :class="{ 'is-active' : toggled }"
                    @click="toggle"
                >
                    <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
                </a>
            </div>
        </div>
        <div v-if="toggled" class="text-sm text-neutral-dark mb-lg md:mb-xl hidden lg:block">
            {{ description }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            description: {
                required: true,
                type: String,
            },
            deliveryMinDate: {
                required: true,
                type: String,
            },
            deliveryMaxDate: {
                required: true,
                type: String,
            },
            areaCodes: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                isLoading: false,
                toggled: false,
                areaCode: null,
                phoneNumber: null,
                startDate: '',
                availablePhoneNumbers: [],
            };
        },
        computed: {
            areaCodesForSelect() {
                const values = Object.keys(this.areaCodes).map((k) => {
                    return {
                        value: this.areaCodes[k].AreaNumberId,
                        label: `${this.areaCodes[k].AreaNumberId} (${this.areaCodes[k].Description})`,
                    };
                });

                return Object.keys(values).map((k) => values[k]);
            },
        },
        watch: {
            async areaCode(newAreaCode) {
                this.isLoading = true;
                this.availablePhoneNumbers = [];
                this.phoneNumber = null;

                if (newAreaCode === null) {
                    return;
                }

                const response = await axios.get(route(
                    'front.api.telephony.available-phone-numbers',
                    newAreaCode
                ));

                this.availablePhoneNumbers = response.data;
                this.isLoading = false;
            },
            phoneNumber() {
                this.update();
            },
            startDate() {
                this.update();
            },
        },
        methods: {
            update() {
                this.$emit('change', this.areaCode, this.phoneNumber, this.startDate);
            },
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>